import React from 'react';
import PropTypes from 'prop-types';

function feathersConnect (Target) {

  function feathersConnect (props, context) {
    return React.createElement(Target, Object.assign({}, props, {
      socket: context.socket,
      feathers: context.feathers
    }));
  }

  feathersConnect.contextTypes = {
    socket: PropTypes.oneOfType([
      PropTypes.bool, PropTypes.object
    ]),
    feathers: PropTypes.oneOfType([
      PropTypes.bool, PropTypes.object
    ])
  };

  return feathersConnect;
}

export default feathersConnect;



// WEBPACK FOOTER //
// ./client/providers/feathersConnect.js